import { Component } from '@angular/core';
import { ICellRendererAngularComp } from '@ag-grid-community/angular';
import { ICellRendererParams } from '@ag-grid-community/core';

@Component({
    selector: 'properties-renderer',
    template: `<span style="margin-left: 5px;margin-right: 5px;"><mat-select  #input  [(ngModel)]="value">
    <mat-option *ngFor="let item of options" value="{{item.value}}">{{item.name}}</mat-option>
  </mat-select></span>`,
    standalone: false
})

export class PropertiesRendererComponent implements ICellRendererAngularComp {
  private params: any;
  public value: string;
  public name: string;
  public options: any;

  constructor(){}

  agInit(params: any): void {
    this.params = params;
    this.value = this.params.value;
    this.name = this.params.name;
    this.options = params.options;
  }

  getValue(): any {
    return this.value;
  }


  refresh(params: ICellRendererParams): boolean {
    return false;
  }
}
